import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './asset/css/custom.css'
import './asset/css/responsive.css'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginReact from '@bugsnag/plugin-react'
import BugsnagPerformance from '@bugsnag/browser-performance'
Bugsnag.start({
  apiKey: '3571e5082dcec69ff0c17f8ab15e5b70',
  plugins: [new BugsnagPluginReact()]
})
BugsnagPerformance.start({ apiKey: '3571e5082dcec69ff0c17f8ab15e5b70' })
const ErrorBoundary = Bugsnag.getPlugin('react')
  .createErrorBoundary(React)


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
